import React from "react";
import {BrowserRouter, Routes, Route, useNavigate} from 'react-router-dom';
import AdminDashboard from "./pages/AdminDashboard";
import Cookies from "js-cookie";
import Login from "./pages/Login";
import UpdateProfile from "./pages/UpdateProfile";
import ShowUsers from "./pages/ShowUsers";
import AddUser from "./pages/AddUser";
import DeleteUser from "./pages/DeleteUser";
import ShowPlayers from "./pages/ShowPlayers";
import ShowStats from "./pages/ShowStats";
import DeletePlayer from "./pages/DeletePlayer";
import Home from "./pages/user/Home";
import Thankyou from "./pages/user/Thankyou";
import Certificate from "./pages/Certificates";
import Events from "./pages/Events";
import AddEvent from "./pages/AddEvent";
import DeleteEvent from "./pages/DeleteEvent";
import Signup from "./pages/user/Signup";
import AthleteProfile from "./pages/user/AthleteProfile";
import Payments from "./pages/Payments";
import TitanLanding from "./pages/user/TitanLanding";
import NotFound from "./pages/NotFound";
import HowItWorks from "./pages/user/HowItWorks";
import Support from "./pages/user/Support";

function App() {
  const getUsername = Cookies.get("username");
  const getRole = Cookies.get("user_role");
  const navigate = useNavigate();

  return (
    <div>
      <Routes>
      {getRole === "Administrator" && (
        <>
          <Route path="/" element={<AdminDashboard />} />
          <Route path="/updateprofile" element={<UpdateProfile />} />
          <Route path="/users" element={<ShowUsers />} />
          <Route path="/adduser" element={<AddUser />} />
          <Route path="/deleteuser/:id" element={<DeleteUser />} />
          <Route path="/players" element={<ShowPlayers />} />
          <Route path="/events" element={<Events />} />
          <Route path="/addevent" element={<AddEvent />} />
          <Route path="/deleteevent/:id" element={<DeleteEvent />} />
          <Route path="/certificates" element={<Certificate />} />
          <Route path="/stats/:id" element={<ShowStats />} />
          <Route path="/deleteplayer/:id" element={<DeletePlayer />} />
          <Route path="/payments" element={<Payments />} />
        </>
      )}

      {getRole === "Coach" && (
        <>
          <Route path="/" element={<AdminDashboard />} />
          <Route path="/players" element={<ShowPlayers />} />
          <Route path="/stats/:id" element={<ShowStats />} />
          <Route path="/deleteplayer/:id" element={<DeletePlayer />} />
          <Route path="/certificates" element={<Certificate />} />
          <Route path="/updateprofile" element={<UpdateProfile />} />
        </>
      )}

      {(getRole === "User" || !getRole) && (
        <>
          <Route path="/" element={<TitanLanding />} />
          <Route path="/start" element={<Home />} />
          <Route path="/Thankyou" element={<Thankyou />} />    
          <Route path="/admin" element={<Login />} />
          <Route path="/login" element={<Login />} />
          <Route path="/signup" element={<Signup />} />
          <Route path="/dashboard" element={<AthleteProfile />} />
          <Route path="/howitworks" element={<HowItWorks />} />
          <Route path="/support" element={<Support />} />
          {/* 404 */}
          <Route path="*" element={<NotFound />} />
        </>
      )}
      </Routes>
    </div>
  );
}

export default App;
